import React from "react";
import { _goToBack } from "routers/helper";

import { Platform, ScrollView, View } from "react-native";
import {
  Input,
  Button,
  Header,
  TextArea,
  InputLabel,
  AvatarPicker,
} from "components";
import { useForm, Controller } from "react-hook-form";

import { sizes, strings } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import { dataUrlToFile, sn } from "utils";
import css from "styles";

import { useUpdateCompany } from "clients/apis";

interface ProfileFormType {
  name?: string;
  description?: string;
  avatar?: AvatarType;
}

export default function CompanyProfile() {
  const auth = useRecoilValue(authAtom);

  const {
    control,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm<ProfileFormType>({
    defaultValues: {
      name: auth?.company?.name,
      description: auth?.company?.description,
      avatar: { uri: auth?.company?.avatar },
    },
  });

  const updateCompanyMut = useUpdateCompany();

  const _onSubmit = () => {
    const { name, description, avatar } = getValues();
    const {
      name: dName,
      description: dDescription,
      avatar: dAvatar,
    } = auth?.company;

    if (
      name === dName &&
      description === dDescription &&
      avatar?.uri === dAvatar
    ) {
      _goToBack();
      return;
    }

    const avatarFile =
      avatar?.uri?.includes("data:image") &&
      dataUrlToFile(avatar?.uri, `profile${Date.now()}`);

    const postData = new FormData();
    postData.append("name", name);
    postData.append("description", description);

    if (Platform.OS === "web") {
      avatarFile && postData.append("avatar", avatarFile, avatarFile?.name);
    }

    if (Platform.OS === "android") {
      avatar?.uri !== auth?.company?.avatar &&
        postData.append("avatar", avatar as any);
    }

    updateCompanyMut.mutate(postData);
  };

  return (
    <>
      <Header title={strings.company_infos} />
      <ScrollView
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{
          width: "100%",
          maxWidth: 640,
          alignSelf: "center",
          padding: sizes.space,
          flexGrow: 1,
        }}
      >
        <View style={{ width: "100%" }}>
          <Controller
            control={control}
            name="avatar"
            render={({ field: { value, onChange } }) => (
              <AvatarPicker avatar={value} onChange={onChange} />
            )}
          />
        </View>

        <InputLabel label={strings.name} />
        <Controller
          name="name"
          control={control}
          rules={{ required: { value: true, message: strings.fill_input } }}
          render={({ field: { onChange, value } }) => {
            return (
              <Input
                value={value}
                onChangeText={onChange}
                placeholder={strings.insert_name}
                icon={{ name: "user" }}
                error={errors.name?.message as string}
              />
            );
          }}
        />

        <InputLabel label={strings.descriptions} />
        <Controller
          name="description"
          control={control}
          render={({ field: { onChange, value } }) => {
            return (
              <TextArea
                value={value}
                onChangeText={onChange}
                placeholder={strings.insert_description}
                icon={{ name: "align-right" }}
              />
            );
          }}
        />
      </ScrollView>

      {/* <View style={css.cover} /> */}

      <View
        style={{
          width: "100%",
          maxWidth: 640,
          alignSelf: "center",
          padding: sizes.space,
        }}
      >
        <View
          style={{
            width: "100%",
            padding: sizes.space,
            maxWidth: sn("100%", "100%", 300, 300),
          }}
        >
          <Button
            style={{ marginTop: 20 }}
            loading={updateCompanyMut.isLoading}
            title={{ value: strings.submit_info }}
            onPress={handleSubmit(_onSubmit)}
          />
        </View>
      </View>
    </>
  );
}
